<template>
  <b-row>
    <b-col cols="10" style="padding:25px">
      <b-card class="mb-2" style="max-width: 100%;">
        <div>
          <div>
            <b-form-textarea
              id="textarea"
              v-model="text"
              @keyup.enter="handleSubmitText()"
              :placeholder="messagePlaceHolder"
              :rows="messageRows"
              :max-rows="messageRowsMax"
              style="overflow-y: visible; border: none"
            />
          </div>
          <div style="color: #605f59">
            <small>{{ text.length }} / {{ textMax }}</small>
            <b-icon
              style="cursor: pointer"
              @click="handleSubmitText(text)"
              class="float-right"
              icon="triangle-half"
              rotate="90"
            />
          </div>
        </div>
      </b-card>
      <div style="color: #d4ad49">
        <small>{{ ionaDisclaimer }}</small>
        <div v-if="false">
          <div>
            SCROLL HEIGHT
            {{ messagesBox.scrollHeight ? messagesBox.scrollHeight : "N/A" }}
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>
<script>
export default {
  name: "Chat_SideBar_Footer",
  components: {},
  props: {
    messageBox: {
      type: HTMLDivElement,
      default: null,
      required: false
    }
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    handleHeartBeatSelect(heartBeat) {
      this.$emit("heartbeat-selected", heartBeat);
    },
    handleSubmitText() {
      this.$emit("submit-text", this.text);
      this.text = "";
    }
  },
  data() {
    return {
      text: "",
      initialMessageSent: false,
      ionaDisclaimer: "IONA is AI and may be incorrect",
      textMax: 500,
      messagePlaceHolder: "Enter Something ...",
      messageRows: 2,
      messageRowsMax: 5,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 40,
        height: 40,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
